import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { me } from "../api";
import NavBar from "../components/NavBar";

export default function Admin() {
  const [user, setUser] = useState(null);
  useEffect(() => { me().then((r) => setUser(r.user)); }, []);
  if (!user) return <div style={{ padding:"1.5rem" }}>Cargando...</div>;

  return (
    <div>
      <NavBar user={user} />
      <main style={{ padding:"1.5rem" }}>
        <Outlet />
      </main>
    </div>
  );
}
